import initialiseModals from "Modules/Modal/ModalManager";

export default {
  initialiseModals: initialiseModals
}